import React, { useState, useEffect, useRef } from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Slide,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Divider,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import _ from "lodash";
import { useFormik } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch } from "react-redux";

import driverApi from "Services/Driver";
import VehicleLeasePurchaseApi from "Services/VehicleLeasePurchase";

//Tabs
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";

//Components

import BasicInformation from "./Basic";
import MPlusInformation from "./MPlusInformation";
import BankInformation from "./Bank";
import Services from "./Services";
import Vehicledocuments from "./Vehicle_documents";
import PreviewDriver from "./Preview";
import Status from "./Status";
import { apiUrl } from "../../../../Constants";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel(props) {
  const { children, value, index, disabled = false, ...other } = props;
   if (value !== index || disabled) {
    return (
       <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>Kindly complete previous steps to proceed further</Typography>
        </Box>
      )}
    </div>

    )
  }
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  disabled: PropTypes.bool, 
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const DriverUpdate = (props) => {
  const {
    openDialog,
    handleClose,
    driverId,
    entityLabel = "Driver",
    showBankInformation = true,
    showMPlusInformation = false,
    documentsTabLabel = "Vehicle documents",
    documentsUserType = "DRIVER",
    statusVariant = "DEFAULT",
  } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const entityLabelLower = entityLabel.toLowerCase();
  const bankTabEnabled = showBankInformation !== false;
  const mPlusTabEnabled = showMPlusInformation === true;
  const basicTabIndex = 0;
  const mPlusTabIndex = mPlusTabEnabled ? 1 : -1;
  const bankTabIndex = bankTabEnabled ? (mPlusTabEnabled ? 2 : 1) : -1;
  const documentsTabIndex = 1 + (mPlusTabEnabled ? 1 : 0) + (bankTabEnabled ? 1 : 0);
  const servicesTabIndex = documentsTabIndex + 1;
  const statusTabIndex = servicesTabIndex + 1;

  //Tabs

  const [value, setValue] = useState(0);
  const [skipButton, setSkipButton] = useState(false);
  const [backButton, setBackButton] = useState(false);
  const [submitButton, setsubmitButton] = useState(true);

  // Modals

  const [previewDriverModal, setPreviewDriverModal] = useState(false);

  // Handle Tab Change

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Skip button and Back Button

  useEffect(() => {
    setBackButton(value > 0);
    setSkipButton(value > 0);
  }, [value]);

  // Handle Back Button

  const handleBackButton = () => {
    const newValue = value - 1;
    setValue(newValue);
  };

  // Handle Next Button

  const handleSkipButton = () => {
    const newValue = value + 1;
    setValue(newValue);
  };

  // Preview Modal

  const handleOpenDriverModal = () => {
    setPreviewDriverModal(true);
  };

  const handleClosePreviewDriverModal = () => {
    setPreviewDriverModal(false);
  };

  const handleOpenVehicleDocumentsTab = () => {
    setValue(documentsTabIndex);
  };

 // Tab 1 - Handle basic info

const [driverData, setDriverData] = useState([]);
  // Handle get driver details

  const handleGetDriverDetails = () => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log('driverdata:->',res?.data?.data)
        setDriverData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    driverApi.getDriverDetailsById(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (driverId !== "") {
      handleGetDriverDetails();
    }
  }, [openDialog]);

  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(driverData)) {
      formik.setFieldValue("firstName", driverData?.firstName);
      formik.setFieldValue("lastName", driverData?.lastName);
      formik.setFieldValue("email", driverData?.email);
      formik.setFieldValue("gender", driverData?.gender);
      formik.setFieldValue("email", driverData?.email);
      formik.setFieldValue("gender", driverData?.gender);
      formik.setFieldValue("country", driverData?.country);
      formik.setFieldValue("countryCode", driverData?.countryCode);
      formik.setFieldValue("mobile", driverData?.mobileNumber);
      formik.setFieldValue("passengerProfileImagefileformat",`${apiUrl}${driverData?.imageLocal}`);
      formik.setFieldValue("passengerProfileImage", `${apiUrl}${driverData?.imageLocal}`);
    }
  }
  updateFormValues();
  }, [driverData]);

  const handleUpdateDrivers = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    let validatationPass = true;

    const data = {
      firstName: formValues?.firstName,
      lastName: formValues?.lastName,
      countryCode: formValues?.countryCode,
      mobileNumber: formValues?.mobile,
      email: formValues?.email,
      image: formValues?.passengerProfileImagefileformat,
      userType: "DRIVER",
      gender: formValues?.gender,
      country: formValues?.country,
   //   address: formValues?.address,
   //   bankAccountNumber: formValues?.bankAccountNumber,
    };
//console.log('data-->',data);
//return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
        showSnackbar({
            message: `${entityLabel} Updated Successfully`,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setValue(1);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || `Error while update ${entityLabelLower}`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    driverApi.updateDriver(driverId, { ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
  initialValues: {
    firstName: "",
    lastName: "",
    email: "",
    gender: "",
    country: "",
    mobile: "",
    countryCode: "",
    passengerProfileImage:"",
    passengerProfileImagefileformat:""
  },
  enableReinitialize: true,
  onSubmit: async (values) => {
    handleUpdateDrivers(values); // Ensure this processes `values` correctly
  },
  });

  /* Tab - M+ Information */

  const handleUpdateDriverProgramInfo = (formValues) => {
    const leasePurchaseId = driverData?.driverProgramInfo?._id;

    if (!leasePurchaseId) {
      dispatch(
        showSnackbar({
          message: `No M+ record found for this ${entityLabelLower}`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));

    const data = {
      startDate: formValues?.startDate,
      monthsActive: formValues?.monthsActive,
      tripAcceptanceRate: formValues?.tripAcceptanceRate,
      cancellationRate: formValues?.cancellationRate,
      averageNumberOfTripsPerWeek: formValues?.averageTripsPerWeek,
      vehicleType: formValues?.vehicleType,
      preferredVehicleMake: formValues?.preferredVehicleMake,
      preferredVehicleColor: formValues?.preferredVehicleColor,
      repaymentPreference: formValues?.repaymentPreference,
      nationalIdNumber: formValues?.nationalIdNumber,
      driversLicenseNumber: formValues?.driversLicenseNumber,
      driversLicenseExpirationDate: formValues?.driversLicenseExpirationDate,
      criminalRecordCertificateReferenceNumber:
        formValues?.criminalRecordCertificateReferenceNumber,
      guarantorName: formValues?.guarantorName,
      guarantorRelationship: formValues?.guarantorRelationship,
      guarantorPhoneNumber: formValues?.guarantorPhoneNumber,
      guarantorIdNumber: formValues?.guarantorIdNumber,
      guarantorAddress: formValues?.guarantorAddress,
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200) {
        dispatch(
          showSnackbar({
            message: `${entityLabel} M+ information updated successfully`,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setValue(bankTabEnabled ? bankTabIndex : documentsTabIndex);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message:
            err?.response?.data?.message ||
            `Error while updating ${entityLabelLower} M+ information`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    VehicleLeasePurchaseApi.updateVehicleLeasePurchase(leasePurchaseId, data).then(
      onSuccess,
      onFailure
    );
  };

  const formikMPlus = useFormik({
    initialValues: {
      startDate: "",
      monthsActive: "",
      tripAcceptanceRate: "",
      cancellationRate: "",
      averageTripsPerWeek: "",
      vehicleType: "",
      preferredVehicleMake: "",
      preferredVehicleColor: "",
      repaymentPreference: "",
      nationalIdNumber: "",
      driversLicenseNumber: "",
      driversLicenseExpirationDate: "",
      criminalRecordCertificateReferenceNumber: "",
      guarantorName: "",
      guarantorRelationship: "",
      guarantorPhoneNumber: "",
      guarantorIdNumber: "",
      guarantorAddress: "",
    },
    validationSchema: yup.object({
      startDate: yup.string().required("Start date is required").nullable(),
      monthsActive: yup.number().typeError("Months must be a number").required("Months is required").nullable(),
      tripAcceptanceRate: yup
        .number()
        .typeError("Acceptance rate must be a number")
        .min(0)
        .max(100)
        .required("Acceptance rate is required")
        .nullable(),
      cancellationRate: yup
        .number()
        .typeError("Cancellation rate must be a number")
        .min(0)
        .max(100)
        .required("Cancellation rate is required")
        .nullable(),
      averageTripsPerWeek: yup
        .number()
        .typeError("Trips / week must be a number")
        .required("Trips / week is required")
        .nullable(),
      vehicleType: yup.string().required("Vehicle is required").nullable(),
      repaymentPreference: yup.string().required("Repayment preference is required").nullable(),
      nationalIdNumber: yup.string().required("National ID number is required").nullable(),
      driversLicenseNumber: yup.string().required("Driver's license number is required").nullable(),
      driversLicenseExpirationDate: yup
        .string()
        .required("License expiration date is required")
        .nullable(),
      guarantorName: yup.string().required("Guarantor name is required").nullable(),
      guarantorRelationship: yup.string().required("Guarantor relationship is required").nullable(),
      guarantorPhoneNumber: yup.string().required("Guarantor phone is required").nullable(),
      guarantorIdNumber: yup.string().required("Guarantor ID number is required").nullable(),
      guarantorAddress: yup.string().required("Guarantor address is required").nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handleUpdateDriverProgramInfo(values);
    },
  });

  useEffect(() => {
    const programInfo = driverData?.driverProgramInfo;

    if (!_.isEmpty(programInfo)) {
      formikMPlus.setFieldValue("startDate", programInfo?.startDate || "");
      formikMPlus.setFieldValue("monthsActive", programInfo?.monthsActive ?? "");
      formikMPlus.setFieldValue("tripAcceptanceRate", programInfo?.tripAcceptanceRate ?? "");
      formikMPlus.setFieldValue("cancellationRate", programInfo?.cancellationRate ?? "");
      formikMPlus.setFieldValue(
        "averageTripsPerWeek",
        programInfo?.averageNumberOfTripsPerWeek ?? ""
      );
      formikMPlus.setFieldValue("vehicleType", programInfo?.vehicleType || "");
      formikMPlus.setFieldValue("preferredVehicleMake", programInfo?.preferredVehicleMake || "");
      formikMPlus.setFieldValue("preferredVehicleColor", programInfo?.preferredVehicleColor || "");
      formikMPlus.setFieldValue("repaymentPreference", programInfo?.repaymentPreference || "");
      formikMPlus.setFieldValue("nationalIdNumber", programInfo?.nationalIdNumber || "");
      formikMPlus.setFieldValue("driversLicenseNumber", programInfo?.driversLicenseNumber || "");
      formikMPlus.setFieldValue(
        "driversLicenseExpirationDate",
        programInfo?.driversLicenseExpirationDate || ""
      );
      formikMPlus.setFieldValue(
        "criminalRecordCertificateReferenceNumber",
        programInfo?.criminalRecordCertificateReferenceNumber || ""
      );
      formikMPlus.setFieldValue("guarantorName", programInfo?.guarantorName || "");
      formikMPlus.setFieldValue("guarantorRelationship", programInfo?.guarantorRelationship || "");
      formikMPlus.setFieldValue("guarantorPhoneNumber", programInfo?.guarantorPhoneNumber || "");
      formikMPlus.setFieldValue("guarantorIdNumber", programInfo?.guarantorIdNumber || "");
      formikMPlus.setFieldValue("guarantorAddress", programInfo?.guarantorAddress || "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [driverData]);

 // Tab 2 - Handle background:  info

const [driverbankData, setDriverbankData] = useState([]);
  // Handle get driver details

  const handleGetDriverbankDetails = () => {
    dispatch(showLoader("Loading please wait..."));

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
       // console.log('driverdata:->',res?.data?.data)
        setDriverbankData(res?.data?.data);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Failed to fetch data",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    driverApi.getDriverbankDetailsById(driverId).then(onSuccess, onFailure);
  };

  useEffect(() => {
    if (driverId !== "") {
      handleGetDriverbankDetails();
    }
  }, [openDialog]);

  useEffect(() => {
    const updateFormValues = async () => {
    if (!_.isEmpty(driverbankData)) {
      formikbank.setFieldValue("bank_account_number", driverbankData?.bank_account_number);
      formikbank.setFieldValue("dob", driverbankData?.dob);
      formikbank.setFieldValue("sort_code", driverbankData?.sort_code);
      formikbank.setFieldValue("Address", driverbankData?.Address);
      formikbank.setFieldValue("postelcode", driverbankData?.postelcode);
      formikbank.setFieldValue("city", driverbankData?.city);
      formikbank.setFieldValue("state", driverbankData?.state);
      formikbank.setFieldValue("country", driverbankData?.country);
      
    }
  }
  updateFormValues();
  }, [driverbankData]);

  const handleUpdateDriversbank = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    let validatationPass = true;

    const data = {
      bank_account_number: formValues?.bank_account_number,
      dob: formValues?.dob,
      sort_code: formValues?.sort_code,
      Address: formValues?.Address,
      postelcode: formValues?.postelcode,
      city: formValues?.city,
      state: formValues?.state,
      country: formValues?.country,
     
    };
console.log('bankdata-->',data);
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
        showSnackbar({
            message: `${entityLabel} Bank details Updated Successfully`,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setValue(2);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || `Error while update ${entityLabelLower}`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };

    driverApi.updateDriverbankdetails(driverId, { ...data }).then(onSuccess, onFailure);
  };

  const formikbank = useFormik({
  initialValues: {
    bank_account_number: "",
    dob:"",
    sort_code:"",
    Address:"",
    postelcode:"",
    city:"",
    state:"",
    country:"",
   
  },
  validationSchema: yup.object({
  bank_account_number: yup.string().required("bank_account_number is required").nullable(),
  dob: yup.string().required("dob is required").nullable(),
  sort_code: yup.string().required("Sort code is required").nullable(),
  Address: yup.string().required("Address is required").nullable(),
  postelcode: yup.string().required("Postel Code is required").nullable(),
  city: yup.string().required("city Code is required").nullable(),
  state: yup.string().required("state Code is required").nullable(),
  country: yup.string().required("country Code is required").nullable(),
  
  }),
  enableReinitialize: true,
  onSubmit: async (values) => {
    handleUpdateDriversbank(values); // Ensure this processes `values` correctly
  },
  }); 


  /* Tabs 4
   *  Handle Services
   */

  const [serviceCreated, setServiceCreated] = useState(false);

  const handleUpdateServices = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
      //console.log('service formValues-->',formValues);
    let data = {
      userId: driverId,
      serviceTypeId: formValues?.service,
      sub_companyName: formValues?.subcompanyname,
      serviceKind: formValues?.serviceType,
      allowedTypes: formValues?.allowedTypes,
      vehicleNumber: formValues?.vehicleNumber,
      vehicleModel: formValues?.vehicleModel,
      driverLicenseNumber: formValues?.driverLicenseNumber,
      licenseExpiryDate: formValues?.licenseExpiryDate,
      vehicleInsuranceNumber: formValues?.vehicleInsuranceNumber,
      insuranceExpiryDate: formValues?.insuranceExpiryDate,
      vehicleColour:formValues?.vehicleColour,
      loginBy: "MANUAL",
      //accountStatus:"APPROVED",
      tripStatus:"READY"
    };
//console.log('data-->',data);
//return false;
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.status === 200 || res?.status === 201) {
        dispatch(
        showSnackbar({
            message: `${entityLabel} service updated successfully`,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
      }
      setServiceCreated(true);
      setValue(statusTabIndex);
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || `Error while update the service of ${entityLabelLower}`,
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    driverApi.updateDriverRide({ ...data }).then(onSuccess, onFailure);
  };

  // Formik Services

  const formikServices = useFormik({
    initialValues: {
      service:"",
      serviceType: "",
      vehicleNumber: "",
      vehicleModel: "",
      driverLicenseNumber: "",
      licenseExpiryDate: "",
      vehicleInsuranceNumber: "",
      insuranceExpiryDate: "",
      subcompanyname:"",
      vehicleColour:"",
      vehicleimage:"",
      allowedTypes: [],
    },
    validationSchema: yup.object({
      service: yup.string().required("Service is required").nullable(),
      serviceType: yup.string().required("Service Type is required").nullable(),
      subcompanyname: yup
    .string()
    .nullable()
    .when("serviceType", {
      is: "ATTACHED_SERVICE",
      then: yup.string().required("Sub-company is required"),
      otherwise: yup.string().nullable(),
    }),
      allowedTypes: yup
      .array()
      .of(yup.string())
      .required("Allowed Types is required")
      .min(1, "At least one allowed type is required")
      .test(
        "includes-service",
        "Allowed Types must include the selected Service",
        function (allowedTypes) {
          const serviceId = this.parent.service; // Get current service _id
          return allowedTypes.includes(serviceId);
        }
      ),
      vehicleNumber: yup
        .string()
        .required("Vechicle Number is required")
        .nullable(),
      vehicleModel: yup
        .string()
        .required("Vechicle Model is required")
        .nullable(),
      driverLicenseNumber: yup
        .string()
        .required("Driver License Model is required")
        .nullable(),
      licenseExpiryDate: yup
        .string()
        .required("License Expirydate is required")
        .nullable(),
      insuranceExpiryDate: yup
        .string()
        .required("Insurance Expirydate is required")
        .nullable(),
      vehicleInsuranceNumber: yup
        .string()
        .required("vehicle Insurance Number is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: async (values) => {
      handleUpdateServices(values); // Ensure this processes `values` correctly
    },
  });

  /**
   * Tabs 6
   * Status
   */

  // Handle Submit

  const basicInformationRef = useRef(null);
  const bankInformationRef = useRef(null);
  const vehicledocsRef = useRef(null);
  const servicesRef = useRef(null);
  const documentsRef = useRef(null);
  const statusRef = useRef(null);
  
  const handleCloseAndReset = () => {

    setValue(0); // Reset tab to 0

     // Call the resetPassengerImage method in BasicInformation
    if (basicInformationRef.current && basicInformationRef.current.resetPassengerImage) {
      basicInformationRef.current.resetPassengerImage();
    }
    formik.setErrors({});
    formik.setTouched({});
    formik.resetForm();

    formikMPlus.setErrors({});
    formikMPlus.setTouched({});
    formikMPlus.resetForm();

    formikServices.setErrors({});
    formikServices.setTouched({});
    formikServices.resetForm();
    handleClose(); // Close the modal
  };

  const handleCloseAllTabs = (data) => {
    if (data) {
      handleCloseAndReset();
    }
  };

  const handleSubmitAndNext = async () => {
    // Tab 1 Basic

    if (value === basicTabIndex) {
      formik.handleSubmit();
    }

    // Tab - M+ Information

    if (mPlusTabEnabled && value === mPlusTabIndex) {
      formikMPlus.handleSubmit();
    }

     // Tab 2 vehicle doc

    if (bankTabEnabled && value === bankTabIndex) {
      formikbank.handleSubmit();
    }
    // Tab 3 vehicle doc

    if (value === documentsTabIndex) {
      setValue(servicesTabIndex)
    }

    // Tab 4 Service

    if (value === servicesTabIndex) {
      // handleClose();
      const servicesData = servicesRef.current();
      if (servicesData) {
        //console.log('servicesData--->',servicesData);
        formikServices.handleSubmit(servicesData);
      }
    }

   // Tab 5 status 
    if (value === statusTabIndex) {
      const statusData = statusRef.current();
      if (statusData) {
        //console.log('statusData--->',statusData);
        handleOpenDriverModal();
      }
    }
  };

  return (
    <>
      <Dialog
        open={openDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"xl"}
        aria-describedby="dialog-box"
        className={classes.root}
      >
        <DialogTitle>
          <section className={classes.dialogTitleContainer}>
        <Typography variant="body1" className={classes.title}>
              Update {entityLabel} Details
            </Typography>
            <IconButton aria-label="close" onClick={handleCloseAndReset}>
              <CloseIcon className={classes.closeIcon} />
            </IconButton>
          </section>
        </DialogTitle>
        <DialogContent>
          {/* Tabs */}
          <Box sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Basic Information"  {...a11yProps(0)} />
                {mPlusTabEnabled && <Tab label="M+ Informations"  {...a11yProps(mPlusTabIndex)} />}
                {bankTabEnabled && <Tab label="Bank Information"  {...a11yProps(bankTabIndex)} />}
                <Tab label={documentsTabLabel}  {...a11yProps(documentsTabIndex)} />
                <Tab label="Services" {...a11yProps(servicesTabIndex)} />
                <Tab label="Status"  {...a11yProps(statusTabIndex)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0} >
              <BasicInformation
                onRef={(ref) => (basicInformationRef.current = ref)}
                driverId={driverId}
                formik={formik}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
                entityLabel={entityLabel}
              />
            </CustomTabPanel>
            {mPlusTabEnabled && (
              <CustomTabPanel value={value} index={mPlusTabIndex} >
                <MPlusInformation
                  formikMPlus={formikMPlus}
                  setsubmitButton={setsubmitButton}
                  setSkipButton={setSkipButton}
                  entityLabel={entityLabel}
                />
              </CustomTabPanel>
            )}
            {bankTabEnabled && (
              <CustomTabPanel value={value} index={bankTabIndex} >
              <BankInformation
                onRef={(ref) => (bankInformationRef.current = ref)}
                driverId={driverId}
                formikbank={formikbank}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
                entityLabel={entityLabel}
              />
            </CustomTabPanel>
            )}
            <CustomTabPanel value={value} index={documentsTabIndex} >
              <Vehicledocuments
                onRef={(ref) => (vehicledocsRef.current = ref)}
                driverId={driverId}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
                entityLabel={entityLabel}
                userType={documentsUserType}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={servicesTabIndex} >
              <Services
                onRef={(ref) => (servicesRef.current = ref)}
                formikServices={formikServices}
                driverId={driverId}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
                entityLabel={entityLabel}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={statusTabIndex} >
              <Status
                openDialog={openDialog}
                onRef={(ref) => (statusRef.current = ref)}
                driverId={driverId}
                openDocumentsTab={handleOpenVehicleDocumentsTab}
                userType="DRIVER"
                documentsUserType={documentsUserType}
                statusVariant={statusVariant}
                setsubmitButton={setsubmitButton}
                setSkipButton={setSkipButton}
                entityLabel={entityLabel}
              />
            </CustomTabPanel>
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <section className={classes.dialogActions}>
            {backButton && (
              <section className={classes.skipBtn}>
                <Button onClick={handleBackButton}>Back</Button>
              </section>
            )}
            {skipButton && (
              <section className={classes.skipBtn}>
                <Button onClick={handleSkipButton}>Skip</Button>
              </section>
            )}
            {submitButton && (
            <section className={classes.submBtn}>
              <Button onClick={handleSubmitAndNext}>Submit & Next</Button>
            </section>
              )}
          </section>
        </DialogActions>
      </Dialog>
      <PreviewDriver
        openDialog={previewDriverModal}
        handleClose={handleClosePreviewDriverModal}
        driverId={driverId}
        setCloseAllTabs={handleCloseAllTabs}
        entityLabel={entityLabel}
      ></PreviewDriver>
    </>
  );
};

export default DriverUpdate;
